import { View } from './view'

export const NotBrokers = View
